import { createSlice } from '@reduxjs/toolkit'
import { AppDispatch } from '@/store'
import { cloneDeep } from 'lodash'
import { getTrackingMeta, postTrackSettings } from '@/services/api'
import * as Types from './types'
import { DOMAIN_MAP } from './constant'
import { localCountries, countryVersion, countryConfig } from '@/utils/countryVersion'

const initialState: Types.InitialState = {
  trackingMate: {},
  trackingLink: '',
}

const trackingSettingSlice = createSlice({
  name: 'trackingSetting',
  initialState,
  reducers: {
    setTrackingMate(state, action) {
      const newTrackingMate = {
        ...state.trackingMate,
        ...action.payload,
      }
      const oneshipHost = localCountries.includes(countryVersion) ? countryConfig.tracking : 'oneship.io'
      const trackingLink = `https://${newTrackingMate.handleCode}.${DOMAIN_MAP[process.env.APP_ENV]}${oneshipHost}`
      return {
        ...state,
        trackingMate: newTrackingMate,
        trackingLink,
      }
    },
  },
})

/** 获取运单轨迹页面配置 */
export const fetchTrackingMeta = () => async (dispatch: AppDispatch) => {
  const response = await getTrackingMeta()
  const { data, bizCode, bizMessage, message } = response
  if (bizCode === 'SUCCESS') {
    const trackingMate = {
      handleCode: data.handleCode,
      ...data.trackingSetting,
    }

    dispatch(setTrackingMate(trackingMate))
    return trackingMate
  }

  return Promise.reject({ bizCode, bizMessage, message })
}

/** 运单轨迹页面配置更新 */
export const updateTrackSettings = (params?: Parameters<typeof postTrackSettings>[0]) => async (dispatch: AppDispatch) => {
  const response = await postTrackSettings(params)
  const { bizCode, bizMessage, message } = response
  if (bizCode === 'SUCCESS') {
    const trackingMate = cloneDeep(params)
    dispatch(setTrackingMate(trackingMate))
    return trackingMate
  }

  return Promise.reject({ bizCode, bizMessage, message })
}

export const { setTrackingMate } = trackingSettingSlice.actions
export default trackingSettingSlice.reducer
